"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var postponed_flights_view_config_model_1 = require("./postponed-flights-view-config.model");
var PostponedFlightsWrapperConfig = (function (_super) {
    __extends(PostponedFlightsWrapperConfig, _super);
    function PostponedFlightsWrapperConfig() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PostponedFlightsWrapperConfig;
}(postponed_flights_view_config_model_1.PostponedFlightsConfig));
exports.PostponedFlightsWrapperConfig = PostponedFlightsWrapperConfig;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/view-config-models/postponed-flights-wrapper-config.model.js